export const PURCHASE_ORDER_RECEPTION_TTL_ES = 'Recepción de Orden de Compra';

export interface IPurchaseOrderReceptionBase {
  providerId: string;
  name: string;
  ruc: string;
}

export interface IPurchaseOrderReception extends IPurchaseOrderReceptionBase {
  id: number;
}

export interface ProductsPurchaseOrderReceptionBody {
  purchaseOrderDetailId: number;
  quantity: number;
  lot: string;
  expAt: Date;
  purchasePrice: number;
}
